export default [
    {
        el: '.j-title',
        langKey: 'title'
    },
    {
        el: '.j-qr-tip',
        langKey: 'qrTip'
    },
    {
        el: '.j-language-selected',
        langKey: 'language'
    },
    {
        el: '.j-card-item-text1',
        langKey: 'cardText1'
    },
    {
        el: '.j-card-item-text2',
        langKey: 'cardText2'
    },
    {
        el: '.j-card-item-text3',
        langKey: 'cardText3'
    },
    {
        el: '.j-card-item-text4',
        langKey: 'cardText3'
    },
    {
        el: '.j-card-item-text5',
        langKey: 'cardText4'
    },
    {
        el: '.j-card-item-text6',
        langKey: 'cardText5'
    },
    {
        el: '.j-card-item-text7',
        langKey: 'cardText6'
    },
    // {
    //     el: '.j-card-item-text8',
    //     langKey: 'cardText7'
    // },
    // {
    //     el: '.j-card-item-text9',
    //     langKey: 'cardText9'
    // },
    {
        el: '.j-quiz-title',
        langKey: 'quizTitle'
    },
    {
        el: '.j-quiz-rule',
        langKey: 'quizRule'
    },
    {
        el: '.j-my-quiz',
        langKey: 'myQuiz'
    },
    {
        el: '.j-quiz-item-title',
        langKey: 'quizItemText1'
    },
    {
        el: '.j-left-title',
        langKey: 'scheduleTitle1'
    },
    {
        el: '.j-right-title',
        langKey: 'scheduleTitle2'
    },
    {
        el: '.j-part3-text',
        langKey: 'p3Text'
    },
    {
        el: '.j-vi-schedule',
        langKey: 'scheduleTitle1'
    },
    {
        el: '.j-th-schedule',
        langKey: 'scheduleTitle2'
    },
    {
        el: '.j-final-schedule',
        langKey: 'scheduleTitle3'
    },
    {
        el: '.j-quizrule-text',
        langKey: 'quizRuleText'
    },
    {
        el: '.j-rule-tip',
        langKey: 'quizRuleTip'
    },
    {
        el: '.j-rule-text',
        langKey: 'ruleText'
    },
    {
        el: '.j-quizconfirm-title',
        langKey: 'quizConfirmText1'
    },
    {
        el: '.j-quizconfirm-tip',
        langKey: 'quizConfirmText2'
    },
    {
        el: '.j-quiznoopen-title',
        langKey: 'quizNoStart1'
    },
    {
        el: '.j-quiznoopen-tip',
        langKey: 'quizNoStart2'
    },
    {
        el: '.j-bind-title',
        langKey: 'bindTitle'
    },
    {
        el: '.j-pServer',
        langKey: 'pServer'
    },
    {
        el: '.j-pRole',
        langKey: 'pRole'
    },
    {
        el: '.j-bind-tip',
        langKey: 'bindTip'
    },
    {
        el: '.j-quiz-table-tip',
        langKey: 'quizLogTip'
    },
    {
        el: '.j-session',
        langKey: 'quizLogSession'
    },
    {
        el: '.j-select',
        langKey: 'quizLogSelect'
    },
    {
        el: '.j-result',
        langKey: 'quizLogResult'
    },
    {
        el: '.j-award',
        langKey: 'quizLogAward'
    },
    {
        el: '.j-logout-btn',
        langKey: 'logout'
    },
    {
        el: '.j-bind',
        langKey: 'bindBtn'
    },
    {
        el: '.j-awardsession',
        langKey: 'awardsession'
    },
    {
        el: '.j-awardname',
        langKey: 'awardname'
    },
    {
        el: '.j-awardsession1',
        langKey: 'session1'
    },
    {
        el: '.j-awardname1',
        langKey: 'award1'
    },
    {
        el: '.j-awardsession2',
        langKey: 'session2'
    },
    {
        el: '.j-awardname2',
        langKey: 'award1'
    },
    {
        el: '.j-awardsession3',
        langKey: 'session3'
    },
    {
        el: '.j-awardname3',
        langKey: 'award1'
    },
    {
        el: '.j-awardsession4',
        langKey: 'session4'
    },
    {
        el: '.j-awardname4',
        langKey: 'award1'
    },
    {
        el: '.j-card-item-date1',
        langKey: 'itemDate1'
    },
    {
        el: '.j-card-item-date2',
        langKey: 'itemDate2'
    },
    {
        el: '.j-card-item-date3',
        langKey: 'itemDate3'
    },
    {
        el: '.j-card-item-date4',
        langKey: 'itemDate4'
    },
    {
        el: '.j-card-item-date5',
        langKey: 'itemDate5'
    },
    {
        el: '.j-card-item-date6',
        langKey: 'itemDate6'
    },
    {
        el: '.j-card-item-date7',
        langKey: 'itemDate7'
    },
    {
        el: '.j-date-item1',
        langKey: 'itemDate3'
    },
    {
        el: '.j-date-item2',
        langKey: 'itemDate4'
    },
    {
        el: '.j-date-item3',
        langKey: 'itemDate5'
    },
    {
        el: '.j-date-item4',
        langKey: 'itemDate6'
    },
    {
        el: '.j-date-item5',
        langKey: 'itemDate7'
    },
    {
        el: '.j-left-flag',
        langKey: 'thirdPlace'
    },
    {
        el: '.j-right-flag',
        langKey: 'thirdPlace'
    },
    {
        el: '.j-top-four-tip',
        langKey: 'topFourTip'
    },
    {
        el: '.j-quiz-tip',
        langKey: 'quizTip'
    },
]